import axios from 'axios';
import { BASE_PATH_API, GIFT_TABLE_ROOT } from 'constants/env';
import { MD5 } from 'crypto-js';
import { decodeStorage } from 'functions/storageBase64';

export async function getElectronicWallet(electronicWalletId, agentToken = null) {
  const token = agentToken || decodeStorage('access_token');
  const accessToken = `Bearer ${token}`;
  const apiURL = `${BASE_PATH_API}/${GIFT_TABLE_ROOT}/electronic-wallet/${electronicWalletId}`;
  const clientSSO = window.localStorage.getItem('profile_id');

  const config = {
    method: 'get',
    url: apiURL,
    withCredentials: false,
    headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json; charset=utf-8',
        'Authorization': accessToken
    }
};

  const res = await axios(config);
  return res.data.data;
}
